import { Account } from '@wizefi/entities';
import { createAction, props } from '@ngrx/store';

export class SpendingComponentActions {
  static init = createAction('[SpendingComponent] init');
  static accountSelected = createAction('[SpendingComponent] selected plan account', props<{ account: Account }>());
}
